import { monteurApi } from '../common/monteur-api';
export var translationApi = monteurApi.injectEndpoints({
    endpoints: function (builder) { return ({
        detectLanguage: builder.mutation({
            query: function (body) { return ({
                url: 'Translation/detect',
                method: 'POST',
                body: body,
                responseHandler: function (response) { return response.text(); }
            }); }
        }),
        translateText: builder.mutation({
            query: function (body) { return ({
                url: 'Translation/translate',
                method: 'POST',
                body: body,
                responseHandler: function (response) { return response.text(); }
            }); }
        })
    }); }
});
export var useDetectLanguageMutation = translationApi.useDetectLanguageMutation, useTranslateTextMutation = translationApi.useTranslateTextMutation;
